import * as i0 from '@angular/core';
import { Directive } from '@angular/core';
import { Subject } from 'rxjs';

class AbstractTuiEditor {
    constructor() {
        this.stateChange$ = new Subject();
        this.valueChange$ = new Subject();
    }
}
AbstractTuiEditor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AbstractTuiEditor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
AbstractTuiEditor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.17", type: AbstractTuiEditor, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: AbstractTuiEditor, decorators: [{
            type: Directive
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractTuiEditor };
